module.exports = __webpack_public_path__ + "img/menu-Member.1bac2c8c.svg";